import script from "./VirMacDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirMacDialog.vue?vue&type=script&setup=true&lang=ts"

import "./VirMacDialog.vue?vue&type=style&index=0&id=d3a08d7e&lang=css"

const __exports__ = script;

export default __exports__